/** Where every call to action sends the buyer. */
export const checkoutUrl = 'https://musician-master.impultienda.ar/checkout'

export const offer = {
  price: 27,
  currency: 'USD',
  productName: 'TeachersKit — 6 Volumes + 6 Bonuses',
}
